const TeamSection = () => null;

export default TeamSection;
